var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSberpayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_11453)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.18188,
    y: 32.4852,
    width: 115.636,
    height: 56.0909,
    rx: 28.0455,
    fill: "#19DD03"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4_11453)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.7943,
    cy: 37.889,
    rx: 26.1517,
    ry: 25.6667,
    fill: "#F2EB00"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4_11453)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.698,
    cy: 92.7154,
    rx: 39.1141,
    ry: 37.8176,
    fill: "url(#paint0_radial_4_11453)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_11453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5854 51.0531C45.3217 52.005 45.945 53.0393 46.4428 54.135L32.3238 64.5432L26.4231 60.8442V56.3941L32.3238 60.0931L44.5854 51.0531Z",
    fill: "white",
    fillOpacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3992 60.53C20.3992 60.3303 20.4041 60.1319 20.4138 59.9347L16.8378 59.7595C16.8257 60.0151 16.8184 60.2731 16.8184 60.5336C16.8168 62.5686 17.2171 64.5837 17.9962 66.4636C18.7753 68.3435 19.9178 70.0511 21.3583 71.4883L23.8949 68.9529C22.786 67.8485 21.9064 66.5358 21.3065 65.0903C20.7066 63.6448 20.3982 62.095 20.3992 60.53Z",
    fill: "white",
    fillOpacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3184 48.611C32.518 48.611 32.7163 48.6183 32.9135 48.628L33.0924 45.0507C32.8361 45.0385 32.578 45.0324 32.3184 45.0324C30.2825 45.0299 28.2663 45.4296 26.3854 46.2085C24.5045 46.9875 22.796 48.1303 21.3579 49.5713L23.8944 52.108C24.9989 50.9987 26.3117 50.1187 27.7574 49.5186C29.203 48.9184 30.753 48.61 32.3184 48.611Z",
    fill: "white",
    fillOpacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.32 72.4505C32.1204 72.4505 31.9219 72.4505 31.7236 72.4347L31.5447 76.0108C31.8019 76.0238 32.0603 76.0303 32.32 76.0303C34.355 76.0324 36.3702 75.6325 38.2501 74.8533C40.13 74.0742 41.8375 72.9312 43.2744 71.4902L40.7427 68.9548C39.6381 70.0634 38.3254 70.9429 36.88 71.5429C35.4346 72.1428 33.8849 72.4513 32.32 72.4505Z",
    fill: "white",
    fillOpacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0373 50.6906L42.051 48.4693C39.2965 46.2387 35.8581 45.0245 32.3137 45.0307V48.6105C34.7138 48.6075 37.0582 49.3328 39.0373 50.6906Z",
    fill: "white",
    fillOpacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8182 60.5307C47.8201 59.5995 47.7387 58.6698 47.5747 57.7531L44.2386 60.2118C44.2386 60.3178 44.2386 60.4236 44.2386 60.5307C44.2394 62.1962 43.8903 63.8433 43.2139 65.3651C42.5375 66.887 41.5488 68.2498 40.312 69.3651L42.7184 72.0247C44.3263 70.5731 45.6112 68.7998 46.4897 66.8197C47.3683 64.8396 47.8209 62.697 47.8182 60.5307Z",
    fill: "white",
    fillOpacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3188 72.4511C30.6532 72.4516 29.0061 72.1024 27.4841 71.426C25.9621 70.7496 24.5991 69.761 23.4834 68.5244L20.8252 70.9296C22.2766 72.5378 24.0498 73.8229 26.0298 74.7018C28.0098 75.5805 30.1524 76.0333 32.3188 76.0308V72.4511Z",
    fill: "white",
    fillOpacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3258 51.6959L21.9207 49.0363C20.3123 50.4877 19.0269 52.2609 18.1479 54.241C17.2689 56.2211 16.816 58.3638 16.8184 60.5303H20.3992C20.3985 58.8649 20.7476 57.2178 21.424 55.6959C22.1005 54.1741 23.089 52.8113 24.3258 51.6959Z",
    fill: "white",
    fillOpacity: 0.96
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.9819 70.0307V50.5427C60.8859 50.4027 62.4819 50.2627 64.9459 50.2627C71.0779 50.2627 73.3179 52.2507 73.3179 56.9267C73.3179 61.9667 70.8259 64.2627 64.9179 64.2627C64.1899 64.2627 63.4619 64.2347 62.7059 64.1507V70.0307H58.9819ZM62.7059 61.0147C63.4899 61.0987 64.1059 61.1267 64.9179 61.1267C68.3059 61.1267 69.4819 59.9787 69.4819 57.1787C69.4819 54.4907 68.4179 53.4267 64.9739 53.4267C64.1619 53.4267 63.4619 53.4267 62.7059 53.5107V61.0147ZM83.3541 70.0307L83.2141 67.8747C82.5421 69.1067 80.9181 70.3667 78.3701 70.3667C75.0381 70.3667 73.4141 68.5467 73.4141 65.7747C73.4141 62.4707 75.3181 61.2387 79.8261 61.2387H83.0181V60.1747C83.0181 58.2707 82.0941 57.5987 79.6301 57.5987C77.7261 57.5987 75.7661 58.4667 74.7021 59.3347V55.7227C75.9621 55.0787 78.1741 54.5747 80.1901 54.5747C84.8381 54.5747 86.6021 56.0027 86.6021 60.0627V70.0307H83.3541ZM77.0541 65.3267C77.0541 66.5867 77.6981 67.4267 79.5181 67.4267C81.9541 67.4267 83.0181 66.1387 83.0181 64.3467V63.3387H80.2181C77.7821 63.3387 77.0541 63.8427 77.0541 65.3267ZM91.2738 72.1867C92.1978 72.1867 92.7298 71.9067 93.3178 70.0867L86.9898 54.9107H91.0498L95.0258 65.6627L98.2458 54.9107H101.942L96.8178 69.5827C95.0538 74.6227 93.6258 75.2947 91.5818 75.2947C90.8538 75.2947 90.0698 75.2107 89.6218 74.9867L89.6498 71.7387C90.0978 71.9907 90.6858 72.1867 91.2738 72.1867Z",
    fill: "white",
    fillOpacity: 0.96
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4_11453",
    x: -35.2665,
    y: -8.68673,
    width: 94.1217,
    height: 93.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.4545,
    result: "effect1_foregroundBlur_4_11453"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4_11453",
    x: 45.6746,
    y: 33.9887,
    width: 120.046,
    height: 117.453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.4545,
    result: "effect1_foregroundBlur_4_11453"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4_11453",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.536 86.1796) rotate(-126.954) scale(28.3382 29.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_11453"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.18188,
    y: 32.4852,
    width: 115.636,
    height: 56.0909,
    rx: 28.0455,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_11453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white",
    transform: "translate(16.8184 45.0307)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSberpayLogo);
export default __webpack_public_path__ + "static/media/sberpay-logo.6c3f8370e613efd590075e4412f82011.svg";
export { ForwardRef as ReactComponent };